var publicPath = __webpack_public_path__;
                    var symbolUrl = 'svg/icons.svg#sparkles';
                    var viewUrl = 'svg/icons.svg#view-sparkles';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 128 128',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };